import { render, staticRenderFns } from "./FormCurrent.vue?vue&type=template&id=56958dc8&scoped=true&"
import script from "./FormCurrent.vue?vue&type=script&lang=js&"
export * from "./FormCurrent.vue?vue&type=script&lang=js&"
import style0 from "./FormCurrent.vue?vue&type=style&index=0&id=56958dc8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56958dc8",
  null
  
)

export default component.exports